"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _flattenSmarttags(stags) {
  var op = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return stags.reduce(function (acc, stag) {
    if (Array.isArray(stag.values) && stag.values.length === 0) {
      return acc;
    }

    acc.push("".concat(stag.key, ":").concat(op ? "".concat(op, ":") : '').concat(stag.values.map(function (v) {
      return v.key;
    })));
    return acc;
  }, []);
}

var smarttagsToUrl = function smarttagsToUrl() {
  var include = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _flattenSmarttags(include).concat(_flattenSmarttags(exclude, 'not')).join('|');
};

var _default = smarttagsToUrl;
exports["default"] = _default;